import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as bookingFlowActions from '../../actions/acBookingFlow'
import { BookingFlowStep as Step } from '../../actions/acBookingFlow'

import pinHome from '../../static/img/pin-home.png'
import { BookingFlowStep, PootsyButton } from "../DesignFunctions"

import ResidencesContainer from '../shared/ResidencesContainer'
import { extractZipCodeFromGeosuggest } from "../../helpers/bookingFlowHelpers";


class BookingFlowResidenceSelection extends Component {

	render() {
		let { t } = this.context

		let headerContent = {
			picto: pinHome,
			title: t('booking_flow_residence_selection_title')
		}

		let zipCode = extractZipCodeFromGeosuggest(this.props.bookingFlow.selectedAddressSuggestion)

		let residences = this.props.residences.filter(r => r.address.zipCode === zipCode)

		return (
			<BookingFlowStep customClass="step-residence-selection" headerContent={headerContent}>

				<ResidencesContainer
					residences={residences}
					residenceSuggestion={this.props.bookingFlow.selectedAddressSuggestion}
					onResidenceSelected={this.onResidenceSelected}
				/>

				<div className="divider"/>

				<div className="bottom">
					<div className="previous-step" onClick={this.goToPreviousStep}>← {t('previous')}</div>
					<PootsyButton
						disabled={!this.isNextButtonEnabled()}
						text={t('next_step')}
						onClick={this.onNextButtonClick}/>
				</div>
			</BookingFlowStep>
		)
	}

	isNextButtonEnabled = () => {
		return this.props.newResidence.streetName && this.props.newResidence.streetNumber && this.props.newResidence.zipCode && this.props.newResidence.city && this.props.newResidence.surface
	}

	onResidenceSelected = (residence) => {
		this.props.dispatch(bookingFlowActions.bookingFlowSelectResidence(residence))
	}

	goToPreviousStep = () => {
		this.props.dispatch(bookingFlowActions.bookingFlowMetaChange({ currentStep: Step.AVAILABILITIES }))
	}

	onNextButtonClick = () => {
		this.props.dispatch(bookingFlowActions.bookingFlowValidateResidenceSelectionStep())
	}
}

BookingFlowResidenceSelection.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	residences: state.dataReducer.residences.residences,
	newResidence: state.dataReducer.residences.newResidence,
	bookingFlow: state.dataReducer.bookingFlow,
})
export default connect(mapStateToProps)(BookingFlowResidenceSelection);


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowResidenceSelection.js